import React from "react"
import {About, Sponsors, Cover} from "./parts"

export default function Home() {
    return (
        <section>
            <Cover/>
            <About/>
            <Sponsors/>
        </section>
    )
}

